import { createRequestTypes } from '../utils';
// import * as orderImportTypes from './orderImportTypes';

export const INITIALIZE_POLLING = createRequestTypes('orderImport/INITIALIZE_POLLING');
export const POLL = createRequestTypes('orderImport/POLL');
export const GOTOHANGFIRE = createRequestTypes('orderImport/GOTOHANGFIRE');
export const ORDER_IMPORT_LIST = createRequestTypes('orderImport/ORDER_IMPORT_LIST');
export const NEW_ORDER_IMPORT = createRequestTypes('orderImport/NEW_ORDER_IMPORT');
export const ORDER_IMPORT = createRequestTypes('orderImport/ORDER_IMPORT');